import React from 'react'
import classNamesBind from 'classnames/bind'
import { personalityIconSrc } from '@dashboard/lib/personality'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface Props {
  padding?: number
  personality: string
  size: number
}

export default class PersonalityIcon extends React.Component<Props> {
  render() {
    const { personality, size, padding } = this.props
    const style = {
      height: `${size}px`,
      width: `${size}px`,
      padding: `${padding || 24}px`,
    }

    return (
      <div
        style={style}
        className={classNames('personalityIcon', `type-${personality}`)}
      >
        <img
          src={personalityIconSrc(personality)}
          className={css.personalityImage}
        />
      </div>
    )
  }
}
